var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMongo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -645.732,
    y1: 839.188,
    x2: -654.59,
    y2: 839.25,
    gradientTransform: "matrix(-0.977, -0.323, -0.29, 0.877, -375.944, -928.287)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#999875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#9b9977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#a09f7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#a9a889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#b7b69a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#c9c7b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#deddcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#f8f6eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf9ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -644.287,
    y1: 823.405,
    x2: -657.028,
    y2: 845.476,
    gradientTransform: "matrix(-0.977, -0.323, -0.29, 0.877, -375.944, -928.287)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48a547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f9143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -643.386,
    y1: 839.485,
    x2: -652.418,
    y2: 833.417,
    gradientTransform: "matrix(-0.977, -0.323, -0.29, 0.877, -375.944, -928.287)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41a247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#4ba74b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#67b554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b655"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_mongo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.62,30l-.751-.249s.1-3.8-1.275-4.067c-.9-1.048.133-44.741,3.423-.149a2.712,2.712,0,0,0-1.333,1.523A14.1,14.1,0,0,0,16.62,30Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.026,26.329a13.223,13.223,0,0,0,5-13.225C20.556,6.619,17.075,4.487,16.7,3.673a9.792,9.792,0,0,1-.825-1.6l.277,18.069S15.578,25.664,17.026,26.329Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.487,26.569S9.366,22.4,9.72,15.025A15.54,15.54,0,0,1,15.239,3.377,1.725,1.725,0,0,0,15.846,2c.381.82.319,12.243.359,13.579C16.36,20.776,15.916,25.588,15.487,26.569Z",
    style: {
      fill: "url(#c)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongo);
export default __webpack_public_path__ + "static/media/mongo.eb842895e80bd61dd471f2b70345feab.svg";
export { ForwardRef as ReactComponent };